<div class="h-full flex flex-col">

  <dx-data-grid
    *ngIf="ready"
    [glamResource]="linksResource"
    [selection]="{ mode: 'none' }"
    [groupPanel]="{ visible: false }"
    [disabledAdd]="true"
    [disabledDelete]="true"
    (refreshEmit)="buildLinks()"
    >

    <dxo-editing
      mode="cell"
      [allowUpdating]="false"
      [allowDeleting]="false"
      [allowAdding]="false"
      />

    <dxi-column
      dataField="code" 
      [caption]="'common.code' | translate | ucfirst"
      cellTemplate="codeTemplate"
      >
      <div *dxTemplate="let cell of 'codeTemplate'" class="hover:underline cursor-pointer">
        <a (click)="navigateToEditor(cell.data)">{{ cell.value }}</a>
      </div>
    </dxi-column>

    <dxi-column
      dataField="name"
      [caption]="'common.name' | translate | ucfirst"
      cellTemplate="nameTemplate"
      >
      <div *dxTemplate="let cell of 'nameTemplate'" class="hover:underline cursor-pointer">
        <a (click)="navigateToEditor(cell.data)">{{ cell.value }}</a>
      </div>
    </dxi-column>

    <dxi-column
      dataField="type"
      [caption]="'entity.type' | translate | ucfirst"
      cellTemplate="typeTemplate"
      >
      <div *dxTemplate="let cell of 'typeTemplate'">
        {{ getTypeName(cell.data) }}
      </div>
    </dxi-column>

    <dxi-column
      dataField="stateId"
      cellTemplate="stateTemplate"
      [caption]="'common.state' | translate | ucfirst"
      [alignment]="'center'"
      >
      <div *dxTemplate="let cell of 'stateTemplate'">
        <div class="px-3 py-1 rounded-full text-white" [style]="{backgroundColor: getStateColor(cell.data)}">
            {{ getStateName(cell.data) }}
        </div>
      </div>
    </dxi-column>

  </dx-data-grid>
</div>
